var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-avatar',{attrs:{"size":"31"}},[_c('img',{staticStyle:{"background-color":"#fff"},attrs:{"src":_vm.src,"alt":"avatar"}})])}
var staticRenderFns = []

export { render, staticRenderFns }